export const roundHalf = (value: number, step: number) => {
  return Math.round(value / step) * step;
}
